import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo.js';

/** Split sign-in layout: product summary on the left, the form card on the right. */
export function AuthLayout({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
}): JSX.Element {
  return (
    <div className="auth-split">
      <aside className="auth-aside">
        <Link to="/" className="site-brand">
          <Logo size={28} />
          <span>Velinko</span>
        </Link>
        <div className="auth-aside-copy">
          <h2>SMS and OTP codes from your phone, in your browser.</h2>
          <ul className="check-list">
            <li>Codes highlighted and copied in one click</li>
            <li>Full SMS history with search and replies</li>
            <li>Built for Samsung Galaxy, light on battery</li>
          </ul>
        </div>
        <p className="muted small">
          Invite-only beta · <Link to="/docs">Docs</Link> · <Link to="/privacy">Privacy</Link>
        </p>
      </aside>
      <main className="auth-page">
        <div className="auth-card">
          <div className="auth-logo">
            <Logo size={40} />
          </div>
          <h1>{title}</h1>
          {subtitle ? <p className="sub">{subtitle}</p> : null}
          {children}
        </div>
      </main>
    </div>
  );
}

/** Shown when the API answers NOT_APPROVED. */
export function NotApprovedNotice({ email }: { email?: string }): JSX.Element {
  return (
    <div className="auth-notice">
      <strong>Waiting for approval</strong>
      <p>
        Velinko is invite-only right now.{' '}
        {email ? (
          <>
            Your request for <b>{email}</b> is recorded.{' '}
          </>
        ) : null}
        You can sign in as soon as the Velinko team approves your email.
      </p>
    </div>
  );
}
